export default "__VITE_ASSET__2234642b__"